import type { ReactNode } from 'react';

import { TextField } from '@mui/material';

import { FieldRow } from './FieldRow';

export interface TextInputFieldProps {
  label: ReactNode;
  description?: ReactNode;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  placeholder?: string;
  multiline?: boolean;
  rows?: number;
  type?: 'text' | 'url' | 'email';
}

/** Labelled single- or multi-line text input laid out as a settings row. */
export function TextInputField({
  label,
  description,
  value,
  onChange,
  disabled = false,
  placeholder,
  multiline = false,
  rows,
  type = 'text',
}: TextInputFieldProps) {
  return (
    <FieldRow label={label} description={description} alignTop={multiline}>
      <TextField
        size="small"
        fullWidth
        type={type}
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        multiline={multiline}
        rows={rows}
        onChange={(event) => onChange(event.target.value)}
        slotProps={{ htmlInput: { 'aria-label': typeof label === 'string' ? label : undefined } }}
      />
    </FieldRow>
  );
}
